var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoPolygonscan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#757575"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5646 9.66597C15.3063 9.51375 14.9705 9.51375 14.6864 9.66597L12.6716 10.833L11.3026 11.5941L9.28784 12.7611C9.02952 12.9133 8.69374 12.9133 8.4096 12.7611L6.80812 11.8478C6.54982 11.6956 6.36902 11.4165 6.36902 11.1121V9.31078C6.36902 9.00635 6.52399 8.72727 6.80812 8.57506L8.38377 7.6871C8.64206 7.53488 8.97786 7.53488 9.26201 7.6871L10.8376 8.57506C11.096 8.72727 11.2768 9.00635 11.2768 9.31078V10.4778L12.6458 9.69134V8.5243C12.6458 8.21987 12.4908 7.9408 12.2067 7.78858L9.28784 6.11416C9.02952 5.96195 8.69374 5.96195 8.4096 6.11416L5.43912 7.78858C5.15498 7.9408 5 8.21987 5 8.5243V11.8985C5 12.203 5.15498 12.482 5.43912 12.6342L8.4096 14.3087C8.66791 14.4609 9.00369 14.4609 9.28784 14.3087L11.3026 13.167L12.6716 12.3805L14.6864 11.2389C14.9446 11.0867 15.2805 11.0867 15.5646 11.2389L17.1402 12.1269C17.3985 12.2791 17.5793 12.5581 17.5793 12.8626V14.6638C17.5793 14.9683 17.4243 15.2474 17.1402 15.3996L15.5646 16.3129C15.3063 16.4651 14.9705 16.4651 14.6864 16.3129L13.1107 15.4249C12.8524 15.2727 12.6716 14.9937 12.6716 14.6892V13.5222L11.3026 14.3087V15.4757C11.3026 15.7801 11.4576 16.0592 11.7417 16.2114L14.7122 17.8858C14.9705 18.0381 15.3063 18.0381 15.5904 17.8858L18.5609 16.2114C18.8192 16.0592 19 15.7801 19 15.4757V12.1015C19 11.797 18.845 11.518 18.5609 11.3658L15.5646 9.66597Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPolygonscan);
export default __webpack_public_path__ + "static/media/ico-polygonscan.eb9688304935ca492e17010c41ec775a.svg";
export { ForwardRef as ReactComponent };